import InfoCircleFilled from '../../src/legacy/InfoCircleFilled.tsx';
export default InfoCircleFilled;
